/*
 *  @2019 CS-Core project.
 *
 */

import Item from "antd/lib/list/Item";

const Constant = {
  /*Project configuration*/
  /*Cấp triển khai 1: Bộ, 2: Địa phương*/
  CAP_TRIEN_KHAI:Number(process.env.REACT_APP_CAP_TRIEN_KHAI),
  MA_DVHC: process.env.REACT_APP_MA_DVHC,
  MA_TINH: process.env.REACT_APP_MA_TINH,
  TEN_DVHC: process.env.REACT_APP_TEN_DVHC,
  GEO_WMS:process.env.REACT_APP_GEO_WMS,
  KEY_GG_DP: 'AIzaSyAITyqM6pDnv6wa5m5b1ssLqpw5lwCuLmw',
  KEY_GG_IF: 'AIzaSyCDJVZlu8THnMxQVMX-1xyWMyEzFLphzuw',
  KINH_TUYEN_TRUC: 24,
  KINH_TUYEN_TRUC_TEN: "107º45'",
  TRAM_QT: 1,
  DIEM_QT: 2,

  CAP_THAM_QUYEN: [
    {id: 1, ten: "Cấp trung ương"},
    {id: 2, ten: "Cấp địa phương"},
  ],

  LOAI_KE_HOACH: [
    {id: 1, ten: "Định kỳ"},
    {id: 2, ten: "Đột xuất"},
  ],

  DANH_GIA_KQQT: [
    {id: 1, ten: "Vượt chỉ số"},
    {id: 2, ten: "Trong ngưỡng cho phép"},
  ],

  TRANG_THAI_BCDK: [
    {id: 1, ten: "Chưa gửi phê duyệt"},
    {id: 2, ten: "Chờ phê duyệt"},
    {id: 3, ten: "Phê duyệt"},
    {id: 4, ten: "Không phê duyệt"},
  ],

  TRANG_THAI_DNCP: [
    {id: 1, ten: "Chưa gửi đề nghị"},
    {id: 2, ten: "Chờ xác nhận"},
    {id: 3, ten: "Đã xác nhận"},
    {id: 4, ten: "Trả lại"},
  ],

  LOAI_BIEU_DO: [
    {id: 1, ten: "Biểu đồ thống kê báo cáo định kỳ"},
    {id: 2, ten: "Biểu đồ thống kê số lần vượt ngưỡng"},
    {id: 3, ten: "Biểu đồ giá trị đo theo thời gian"},
  ],

  NHOM_CONG_TRINH: [
    {id: 3, maCongTrinh: 3, moTa: "Công trình nước mặt", tenNhomCongTrinh: "Công trình nước mặt", key: "CTNM_GiayPhepCongTrinh"},
    {id: 1, maCongTrinh: 1, moTa: "Công trình nước dưới đất", tenNhomCongTrinh: "Công trình nước dưới đất", key: "CTNDD_GiayPhepCongTrinh"},
    {id: 4, maCongTrinh: 4, moTa: "Công trình nước biển", tenNhomCongTrinh: "Công trình nước biển", key: "CTNB_GiayPhepCongTrinh"},
    {id: 2, maCongTrinh: 2, moTa: "Công trình xả thải", tenNhomCongTrinh: "Công trình xả thải", key: "CTXT_GiayPhepCongTrinh"},
  ],

  DICT_LHGP: {
    CAP_MOI: 1,
    CAP_LAI: 2,
    GIA_HAN: 3,
    THU_HOI: 4,
  },
  LHPD:{
    PHE_DUYET_MOI: 1,
    PHE_DUYET_DIEU_CHINH: 2,
  },

  DICT_NHOM_CT: {
    NDD: 1,
    XT: 2,
    NM: 3,
    NB: 4
  },

  LOAI_CONG_TRINH: [
    {id: 3, maLoaiCongTrinh: 3, moTa: "Công trình thủy điện", tenLoaiCongTrinh: "Công trình thủy điện", key: "CTNM_ThuyDien", thongTinCT: "ctnM_ThuyDien"},
    {id: 4, maLoaiCongTrinh: 4, moTa: "Công trình hồ chứa↵", tenLoaiCongTrinh: "Công trình hồ chứa", key: "CTNM_HoChua", thongTinCT: "ctnM_HoChua"},
    {id: 5, maLoaiCongTrinh: 5, moTa: "Công trình bai đập", tenLoaiCongTrinh: "Công trình bai đập", key: "CTNM_BaiDap", thongTinCT: "ctnM_BaiDap"},
    {id: 6, maLoaiCongTrinh: 6, moTa: "Công trình trạm bơm", tenLoaiCongTrinh: "Công trình trạm bơm", key: "CTNM_TramBom", thongTinCT: "ctnM_TramBom"},
    {id: 7, maLoaiCongTrinh: 7, moTa: "Công trình cống", tenLoaiCongTrinh: "Công trình cống", key: "CTNM_Cong", thongTinCT: "ctnM_Cong"},
    {id: 8, maLoaiCongTrinh: 8, moTa: "Công trình trạm cấp nước", key: "CTNM_TramCapNuoc", thongTinCT: "ctnM_TramCapNuoc"},
    {id: 9, maLoaiCongTrinh: 9, moTa: "Công trình nhà máy nước", key: "CTNM_NhaMayNuoc", thongTinCT: "ctnM_NhaMayNuoc"},
    {id: 10, maLoaiCongTrinh: 10, moTa: "Công trình xả thải", tenLoaiCongTrinh: "Công trình xả thải", key: "CTXT_CongTrinh_Input", thongTinCT: "ctnM_ThuyDien"},
    {id: 11, maLoaiCongTrinh: 11, moTa: "Công trình khai thác nước biển", key: "CTKTNB_CongTrinh_Input", thongTinCT: "CTKTNB_CongTrinh_Input"},
    {id: 2, maLoaiCongTrinh: 2, moTa: "Công trình khai thác nước dưới đất", key: "CTNDD_CongTrinh_Input", thongTinCT: "ctndD_CongTrinh"},
    {id: 1, maLoaiCongTrinh: 1, moTa: "Công trình thăm dò nước dưới đất", key: "CTNDD_CongTrinhThamDo_Input", thongTinCT: "ctndD_CongTrinhThamDo"}
  ],

  DICT_LOAI_CT: {
    NDD_THAMDO: 1,
    NDD_KHAITHAC: 2,
    NM_THUYDIEN: 3,
    NM_HOCHUA: 4,
    NM_BAIDAP: 5,
    NM_TRAMBOM: 6,
    NM_CONG: 7,
    NM_TRAMCAPNUOC: 8,
    NM_NHAMAYNUOC: 9,
    XT: 10,
    NB_KT: 11
  },

  HE_SO_KQ: [
    {id: 0, ten: "0.6",value: 0.6},
    {id: 1, ten: "0.8",value: 0.8},
    {id: 2, ten: "0.9",value: 0.9},
    {id: 3, ten: "1",value: 1},
    {id: 4, ten: "1.1",value: 1.1},
    {id: 5, ten: "1.2",value: 1.2},
    {id: 6, ten: "1.3",value: 1.3},
  ],

  HE_SO_KF: [
    {id: 0, ten: "0.9",value: 0.9},
    {id: 1, ten: "1.0",value: 1.0},
    {id: 2, ten: "1.1",value: 1.1},
    {id: 3, ten: "1.2",value: 1.2},
    {id: 4, ten: "1.3",value: 1.3},
  ],

  DOI_TUONG_QUAN_TRAC : [
    {id: 1, maCongTrinh: 1, moTa: "Công trình nước mặt"},
    {id: 2, maCongTrinh: 2, moTa: "Công trình nước dưới đất"},
    {id: 3, maCongTrinh: 3, moTa: "Công trình xả thải"},
    {id: 4, maCongTrinh: 4, moTa: "Công trình nước biển"},
  ],

  LOAI_THOI_HAN: [
    {id: 1, ten: "Toàn thời gian"},
    {id: 2, ten: "Theo giai đoạn"},
  ],
 LOAI_HINH_PHE_DUYET: [
    {id: 1, ten: "Phê duyệt mới"},
    {id: 2, ten: "Phê duyệt điều chỉnh"},
  ],

  TRANG_THAI_CAP_PHEP_NDD: [
    { id: 2, name: "Chưa cấp phép" },
    { id: 1, name: "Đã cấp phép" },
  ],
  HIEU_LUC_GIAY_PHEP_BO: [
    { id: 0, ten: "Còn hiệu lực" },
    { id: 1, ten: "Hết hiệu lực" },
    { id: 2, ten: "Chưa phê duyệt" },
    { id: 3, ten: "Sắp hết hiệu lực" },
    { id: 4, ten: "Hết hiệu lực nhưng chưa có GP thay thế" },
    { id: -1, ten: "Chưa bắt đầu hiệu lực"},
    { id: 7, ten: "Hết hiệu lực(Có GP thay thế)"},
     
  ],

  HIEU_LUC_GIAY_PHEP_TINH: [
    { id: 0, ten: "Còn hiệu lực" },
    { id: 1, ten: "Hết hiệu lực" },
    { id: 3, ten: "Sắp hết hiệu lực" },
    { id: 4, ten: "Hết hiệu lực nhưng chưa có GP thay thế" },
    { id: -1, ten: "Chưa bắt đầu hiệu lực"},
     { id: 7, ten: "Hết hiệu lực(Có GP thay thế)"},
  ],
  HIEU_LUC_GIAY_PHEP: [
    { id: 2, ten: "Còn hiệu lực" },
    { id: 1, ten: "Hết hiệu lực" },
  ],
  LOAI_HINH_GIAY_PHEP: [
    {id: 1, ten: "Cấp mới giấy phép"},
    {id: 2, ten: "Cấp lại giấy phép"},
    {id: 3, ten: "Gia hạn, điều chỉnh giấy phép"},
    {id: 4, ten: "Thu hồi giấy phép"},
  ],
  THANH_PHAN_MOI_TRUONG: [
    {id: 1, ten: "Nước mặt"},
    {id: 2, ten: "Nước dưới đất"},
    {id: 3, ten: "Nước xả thải"},
    {id: 5, ten: "Không khí ngoài trời, tiếng ồn, độ rung"},
    {id: 9, ten: "Nước biển"},
    {id: 10, ten: "Nước mưa"},
    {id: 11, ten: "Khí thải"},
    {id: 12, ten: "Đất"},
    {id: 13, ten: "Trầm tích"},
    {id: 14, ten: "Chất thải nguy hại"},
  ],

  DOI_TUONG_QUAN_TRAC: [
    { id: 1, ten: "Nước mặt" },
    { id: 2, ten: "Nước dưới đất" },
    { id: 3, ten: "Nước xả thải" },
  ],

  THANH_PHAN_MOI_TRUONG_TEN: {
    1: "Nước mặt",
    2: "Nước dưới đất",
    3: "Nước xả thải",
    5: "Không khí ngoài trời, tiếng ồn, độ rung",
    9: "Nước biển",
    10: "Nước mưa",
    11: "Khí thải",
    12: "Đất",
    13: "Trầm tích",
    14: "Chất thải nguy hại"
  },
  
  MUI_CHIEU: [
    {id: 3, ten: "Múi chiếu 3 độ"},
    {id: 6, ten: "Múi chiếu 6 độ"},
  ],

  DATA_SELECT: [
    { name: "=", value: "=", },
    { name: ">", value: ">", },
    { name: "<", value: "<", },
    { name: "<=", value: "<=", },
    { name: ">=", value: ">=", },
  ],
  DASHBOARD:{
    NDD: "báo cáo định kỳ khai thác sử dụng nước dưới đất",
    NM: "báo cáo định kỳ khai thác sử dụng nước mặt nước mặt",
    XT: "báo cáo định kỳ xả thải vào nguồn nước",
    VHL: "báo cáo quan trắc định kỳ Vịnh Hạ Long",
    BVMT: "báo cáo định kỳ KSON BVMT",
    HTMT: "báo cáo quan trắc định kỳ hiện trạng môi trường",
    NTTS: "báo cáo quan trắc định kỳ thủy sản",
    TDMT: "báo cáo định kỳ KSON ĐTM",
    QDXP: "quyết định xử phạt vi phạm hành chính",
  },
  HUONG_GIO: [
    {id: 9, ten: "-"},
    {id: 1, ten: "B"},
    {id: 2, ten: "ĐB"},
    {id: 3, ten: "Đ"},
    {id: 4, ten: "ĐN"},
    {id: 5, ten: "N"},
    {id: 6, ten: "TN"},
    {id: 7, ten: "T"},
    {id: 8, ten: "TB"},
  ],
  GiayPhep_Sort: [
    { id: 1, name: "Sắp xếp theo số giấy phép" },
    { id: 2, name: "Sắp xếp theo ngày ký" },
    { id: 3, name: "Sắp xếp theo tên công trình" },
    { id: 4, name: "Sắp xếp theo tên ĐVXCP" },
    { id: 5, name: "Sắp xếp theo ngày bắt đầu hiệu lực" },
    { id: 6, name: "Sắp xếp theo ngày kết thúc hiệu lực" },

  ],
  GiayPhep_isBCDK: [
    { id: 1, name: "Đã báo cáo" },
    { id: 2, name: "Chưa báo cáo" },
  ],
  GiayPhep_SortHN: [
    { id: 1, name: "Sắp xếp theo số giấy phép" },
    { id: 2, name: "Sắp xếp theo ngày ký" },
    { id: 4, name: "Sắp xếp theo tên ĐVXCP" },
    { id: 5, name: "Sắp xếp theo ngày bắt đầu hiệu lực" },
    { id: 6, name: "Sắp xếp theo ngày kết thúc hiệu lực" },
  ],
  Sort: [
    { id: 1, name: "Tăng dần" },
    { id: 2, name: "Giảm dần" },
  ],
  KET_QUA_QUAN_TRAC: [
    { id: 0, name: "Chưa đánh giá" },
    { id: 1, name: "Vượt chỉ số" },
    { id: 2, name: "Bình thường" },
  ],

  PHE_DUYET: [
    { id: 0, name: "Đã phê duyệt" },
    { id: 1, name: "Chưa phê duyệt" },
  ],

  DIEM_QT_BANDO: {
    DTM: 1,
    BVMT: 2,
    HTMT: 3,
    NTTS: 4,
    VHL: 5,
    TTKT_KH: 6,
    TTKT_QDXP: 7,
    CAT_KH: 8,
    CAT_QDXP: 9,
    TNN: 10
  },
  CAU_HINH_THOI_GIAN: {
    NM: "SHHL_NM",
    NDD_KT: "SHHL_NDD_KT",
    NDD_TD: "SHHL_NDD_TD",
    XT: "SHHL_XT",
    NB: "SHHL_NB",
    HN: "SHHL_HN",
    BCDK: "SoLanTraLai"
  }
};

export const groupFunctionsCode = {
  TRANG_CHU: "quantrac_cscore_1_1",
  TNN: "quantrac_cscore_2",
  DTM: "quantrac_cscore_3",
  BVMT: "quantrac_cscore_4",
  HTMT: "quantrac_cscore_5",
  NTTS: "quantrac_cscore_6",
  QTVHL: "quantrac_cscore_7",
  TTKT: "quantrac_cscore_8",
  CHTS: "quantrac_cscore_9",
  DMQT: "quantrac_cscore_10",
  DM: "quantrac_cscore_11",
  BD: "quantrac_cscore_12",
  BCTK: "quantrac_cscore_13",
  NKHT: "quantrac_cscore_14",
  TKDN: "quantrac_cscore_15_1",
  CAT: "quantrac_cscore_16",
  BCDN:"quantrac_cscore_17",
  MT: "quantrac_cscore_18",
};

export const functionsCode = {
  TRANG_CHU: "quantrac_cscore_1_1",
  //TÀI NGUYÊN NƯỚC
  TNN_XT: "quantrac_cscore_2_1",
  TNN_NM: "quantrac_cscore_2_2",
  TNN_NB: "quantrac_cscore_2_3",
  TNN_KTNDD: "quantrac_cscore_2_4",
  TNN_TDNDD: "quantrac_cscore_2_5",
  TNN_HN: "quantrac_cscore_2_6",
  TNN_BCDK: "quantrac_cscore_2_7",
  TNN_TQT: "quantrac_cscore_2_8",
  //ĐTM
  DTM_BCPD: "quantrac_cscore_3_1",
  DTM_BCDK: "quantrac_cscore_3_2",
  DTM_TQT: "quantrac_cscore_3_3",
  //BẢO VỆ MÔI TRƯỜNG
  BVMT_DACT: "quantrac_cscore_4_1",
  BVMT_BCDK: "quantrac_cscore_4_2",
  BVMT_TQT: "quantrac_cscore_4_3",
  //HIỆN TRẠNG MÔI TRƯỜNG
  HTMT_BCDK: "quantrac_cscore_5_1",
  HTMT_TQT: "quantrac_cscore_5_2",
  //NUÔI TRỒNG THỦY SẢN
  NTTS_BCDK: "quantrac_cscore_6_1",
  NTTS_TQT: "quantrac_cscore_6_2",
  //Quan trắc vịnh hạ long
  QTVHL: "quantrac_cscore_7_1",
  QTVHL_TQT: "quantrac_cscore_7_2",
  //THANH TRA KIỂM TRA
  QDXPVP: "quantrac_cscore_8_1",
  QDXPVP_TQT: "quantrac_cscore_8_2",
  QDXPVP_KHTKT: "quantrac_cscore_8_3",
  QDXPVP_TQT_TKT: "quantrac_cscore_8_4",
  //CẤU HÌNH THÔNG SỐ
  CHTS_TS: "quantrac_cscore_9_1",
  CHTS_QC: "quantrac_cscore_9_2",
  //DANH MỤC QUAN TRẮC
  DMQT_DVD: "quantrac_cscore_10_1",
  DMQT_PPLM: "quantrac_cscore_10_2",
  DMQT_PPPT: "quantrac_cscore_10_3",
  DMQT_MDSD: "quantrac_cscore_10_4",
  DMQT_TQT: "quantrac_cscore_10_5",
  DMQT_DVTH: "quantrac_cscore_10_6",
  DMQT_DQT: "quantrac_cscore_10_7",
  DMQT_KQT: "quantrac_cscore_10_8",
  DMQT_TSQT: "quantrac_cscore_10_9",
  DMQT_TCAP: "quantrac_cscore_10_10",
  DMQT_TCDG: "quantrac_cscore_10_11",
  DMQT_TQT: "quantrac_cscore_10_12",
  DMQT_DA: "quantrac_cscore_10_13",
  DMQT_TPMT: "quantrac_cscore_10_14",
  //DANH MUC
  DM_PLBC: "quantrac_cscore_11_1",
  DM_LBD: "quantrac_cscore_11_2",
  DM_LVB: "quantrac_cscore_11_3",
  DM_CSDL: "quantrac_cscore_11_4",
  DM_LCT: "quantrac_cscore_11_5",
  DM_KTT: "quantrac_cscore_11_6",
  DM_MDSDN: "quantrac_cscore_11_7",
  DM_LHNT: "quantrac_cscore_11_8",
  DM_DVQLCT: "quantrac_cscore_11_9",
  DM_KCN: "quantrac_cscore_11_10",
  DM_TCCNDCP: "quantrac_cscore_11_11",
  DM_LN: "quantrac_cscore_11_12",
  DM_NM: "quantrac_cscore_11_13",
  DM_DVTD: "quantrac_cscore_11_14",
  //BẢN ĐỒ
  BD_TCTNN: "quantrac_cscore_12_1",
  BD_SVLVS: "quantrac_cscore_12_2",
  //BÁO CÁO THỐNG KÊ
  BCTK_BM1: "quantrac_cscore_13_1",
  //NHẬT KÝ HỆ THỐNG 
  NKHT_GS: "quantrac_cscore_14_1",
  NKHT_TNN: "quantrac_cscore_14_2",
  //Tìm kiếm doanh nghiệp
  TKDN: "quantrac_cscore_15_1",
  // Công an tỉnh
  CAT_QDXPVP: "quantrac_cscore_16_1",
  CAT_TQT: "quantrac_cscore_16_2",
  CAT_KHTKT: "quantrac_cscore_16_3",
  CAT_TQT_KHTKT: "quantrac_cscore_16_4",
  // Báo cáo cho doanh nghiệp
  BCDN_TNN:"quantrac_cscore_17_1",
  BCDN_DTM:"quantrac_cscore_17_2",
  BCDN_BVMT:"quantrac_cscore_17_3",
  BCDN_HDSD:"quantrac_cscore_17_4",
  BCDN_CNCP:"quantrac_cscore_17_5",
  BCDN_BC: "quantrac_cscore_17_6",
};

export default Constant;
